export default () => ({
    type: "DATA_RETRIEVAL_ENDED",
    data: false
});